/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CompanyChangeAvatarImageRequestDto
 */
export interface CompanyChangeAvatarImageRequestDto {
  /**
   *
   * @type {string}
   * @memberof CompanyChangeAvatarImageRequestDto
   */
  value: string;
}

export function CompanyChangeAvatarImageRequestDtoFromJSON(json: any): CompanyChangeAvatarImageRequestDto {
  return CompanyChangeAvatarImageRequestDtoFromJSONTyped(json, false);
}

export function CompanyChangeAvatarImageRequestDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CompanyChangeAvatarImageRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    value: json["value"],
  };
}

export function CompanyChangeAvatarImageRequestDtoToJSON(value?: CompanyChangeAvatarImageRequestDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    value: value.value,
  };
}
